export default {
  headerTitle: 'Markers',
  markerTitle: 'Marker {0}',
  markersHint: 'Click on map for adding new marker',
};
